"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartMapper = void 0;
var AddToCartMapper = /** @class */ (function () {
    function AddToCartMapper(data) {
        this.localData = data;
    }
    AddToCartMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AddToCartMapper;
}());
exports.AddToCartMapper = AddToCartMapper;
//# sourceMappingURL=AddToCartMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AddToCartMapper.js
// module id = 2219
// module chunks = 8